(function () {
  if (window.__anivDD) { window.__anivDD.scan(); return; }
  window.__anivDD = { scan: scan };

  // Dentro do editor de temas a secao nunca pode se esconder sozinha: quem
  // acabou de adiciona-la precisa ve-la para configurar. Sem isto o Liquid
  // renderiza a secao e o JS a escondia logo em seguida, deixando o editor
  // em branco sem explicacao.
  var EDITOR = !!(window.Shopify && window.Shopify.designMode);

  // Pre-visualizacao de campanha fora das datas.
  //   ?campanha=preview  liga e GRUDA na aba (sessionStorage)
  //   ?campanha=off      desliga
  // Gruda de proposito: o botao "Visualizar" do admin abre a loja sem
  // parametro nenhum, e qualquer clique no menu apagaria a flag da URL.
  // Fica so nesta aba, entao nao vaza para cliente nenhum.
  var FORCA = false;
  (function () {
    var liga = /[?&]campanha=preview(&|$)/.test(window.location.search);
    var desliga = /[?&]campanha=off(&|$)/.test(window.location.search);
    try {
      if (liga) sessionStorage.setItem('anivPreview', '1');
      if (desliga) sessionStorage.removeItem('anivPreview');
      FORCA = sessionStorage.getItem('anivPreview') === '1';
    } catch (e) {
      FORCA = liga && !desliga;          // navegacao anonima com storage bloqueado
    }
  })();

  function dois(n) { return n < 10 ? '0' + n : String(n); }

  function init(root) {
    if (root.__aniv) clearInterval(root.__aniv);
    if (root.__anivTick) clearInterval(root.__anivTick);
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-aniv-card]'));
    var preview = root.getAttribute('data-preview') || 'auto';
    var drift = 0;
    var seed = parseInt(root.getAttribute('data-server-now'), 10);
    if (seed > 0) drift = seed * 1000 - Date.now();
    if (window.fetch) {
      fetch('/cart.js', { method: 'HEAD', cache: 'no-store' })
        .then(function (r) { var t = Date.parse(r.headers.get('Date')); if (!isNaN(t)) drift = t - Date.now(); })
        .catch(function () {});
    }

    var ini = parseInt(root.getAttribute('data-start'), 10) * 1000;
    var fim = parseInt(root.getAttribute('data-end'), 10) * 1000;
    var dayLen = parseInt(root.getAttribute('data-daylen'), 10) || 86399;
    var ciclo = parseInt(root.getAttribute('data-cycle'), 10) || 7;
    // Duracao de cada variacao em segundos: 1 dia no Aniversario, 7 na Black
    // Friday. O relogio conta ate o fim do periodo corrente, nao da campanha.
    var periodo = (parseInt(root.getAttribute('data-periodo'), 10) || 86400) * 1000;
    var timer = root.querySelector('[data-aniv-timer]');
    var fimPeriodo = parseInt(root.getAttribute('data-fim'), 10) * 1000;

    function posicaoAtual(now) {
      if (preview === 'off') return 0;
      if (preview === 'live' || FORCA) return 1;
      if (!ini || !fim || now < ini || now >= fim) return 0;
      var delta = now - ini;
      if (periodo <= 86400000 && Math.floor(delta / 1000) % 86400 > dayLen) return 0;
      return (Math.floor(delta / periodo) % ciclo) + 1;
    }

    // Quem decide se a secao some:
    //   "off"  — escolha explicita de quem edita, some sempre.
    //   "live" — escolha explicita de quem edita, fica sempre.
    //   "auto" — some quando nao ha card para mostrar, exceto no editor ou
    //            com a pre-visualizacao ligada.
    function deveEsconder(pos, mostrados) {
      if (preview === 'off') return true;
      if (preview === 'live') return false;
      if (EDITOR || FORCA) return false;
      return !pos || mostrados === 0;
    }

    function render() {
      var pos = posicaoAtual(Date.now() + drift);
      root.setAttribute('data-state', pos ? 'live' : 'off');
      // Cards de produto que saiu do ar nem chegam no HTML (o Liquid pula),
      // entao contar os visiveis diz se o dia tem oferta de verdade.
      var mostrados = 0;
      cards.forEach(function (c) {
        var on = pos > 0 && parseInt(c.getAttribute('data-pos'), 10) === pos;
        if (on) mostrados++;
        if (c.hidden === on) c.hidden = !on;
      });
      var esconder = deveEsconder(pos, mostrados);
      if (root.hidden !== esconder) root.hidden = esconder;
    }

    function marca(u, v, mostrar) {
      var el = timer.querySelector('[data-u="' + u + '"]');
      if (!el) return;
      el.textContent = dois(v);
      el.style.display = mostrar ? '' : 'none';
      var rot = el.nextElementSibling;
      if (rot && rot.tagName === 'I') rot.style.display = mostrar ? '' : 'none';
    }

    function tick() {
      if (!timer) return;
      var agora = Date.now() + drift;
      // Virou o periodo: avanca o alvo e troca os produtos sem recarregar.
      while (fimPeriodo > 0 && agora >= fimPeriodo && fimPeriodo < fim) {
        fimPeriodo += periodo;
        render();
      }
      var resta = Math.floor((fimPeriodo - agora) / 1000);
      // Na pre-visualizacao antes da campanha nao existe periodo corrente,
      // entao o relogio conta ate o inicio so para a peca nao ficar vazia.
      if (!fimPeriodo && FORCA && ini > agora) resta = Math.floor((ini - agora) / 1000);
      if (resta <= 0 || root.hidden) { timer.hidden = true; return; }
      var d = Math.floor(resta / 86400);
      // Faltando dias, os segundos so poluem — entram no ultimo dia, quando
      // a pressa passa a ser informacao util.
      marca('d', d, d > 0);
      marca('h', Math.floor(resta % 86400 / 3600), true);
      marca('m', Math.floor(resta % 3600 / 60), true);
      marca('s', resta % 60, d === 0);
      timer.hidden = false;
    }

    render();
    tick();
    root.__aniv = setInterval(render, 30000);
    if (timer) root.__anivTick = setInterval(tick, 1000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) { render(); tick(); } });
  }

  function scan() { Array.prototype.forEach.call(document.querySelectorAll('[data-aniv-root]'), init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); } else { scan(); }
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-aniv-root]'); if (r) init(r);
  });
})();